
        var normalize = require("../../../node_modules/san-loader/lib/runtime/normalize.js");
        require('/Users/duanhong/Source/Lean/LeanPM/webapps/shared/src/components/OrganizationsListTree/OrganizationsListTree.san?lang=less&san=&type=style&index=0');
var injectStyles = [];

        var template = require('./OrganizationsListTree.html');
        
        var script = require('./OrganizationsListTree.ts').default;
        module.exports = require('./OrganizationsListTree.ts');
    
        module.exports.default = normalize(script, template, injectStyles);
        /* san-hmr component */
    